import React from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

interface StopMessageConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  error?: string | null;
}

const StopMessageConfirmDialog: React.FC<StopMessageConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
  error,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      slotProps={{
        paper: { sx: { maxWidth: "38%", maxHeight: "100%" } },
      }}>
      <DialogTitle sx={{ textAlign: "center", fontSize: "1.5rem" }}>
        Stop Sending Message
      </DialogTitle>
      <DialogContent dividers sx={{ pt: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <WarningAmberIcon color="warning" fontSize="medium" />
          <Typography
            variant="body1"
            sx={{ fontSize: "1.1rem", fontWeight: 500 }}>
            Are you sure? This cannot be undone.
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Stopping this send will immediately halt delivery to any remaining
          recipients.
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions
        sx={{ justifyContent: "space-between", px: 3, pb: 2, mt: 1 }}>
        <Button onClick={onClose} color="primary" disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{ backgroundColor: "#fd6c33" }}
          disabled={loading}
          startIcon={
            loading ? <CircularProgress size={16} color="inherit" /> : null
          }>
          {loading ? "Stopping..." : "Stop Send"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StopMessageConfirmDialog;
